import { GoogleLocationData } from './google-location-data';

export interface GoogleGeocodeApiResponse {
  results: GoogleLocationData[];
  status: string;
}
